"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.operation_calcAgent = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonOperationNode_1 = require("../../commonOperationNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const commonProps = (0, commonOperationNode_1.commonZodOperationNodeUtils)(types_1.nodeType, types_1.UiConfigSchema, 'CalcAgent');
// create a new UI node of this type.
const createNewNode = ({ id, creditFacilitySlug, nodeToCopy, }) => {
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            description: 'CalcAgent Configurations goes here',
            creditFacilitySlug,
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(commonProps.isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ node, friendlyName, inputs, outputs, graph, }) => {
    (0, common_1.finleyAssert)(commonProps.isNode(node), `node must be a ${types_1.nodeType} node`);
    const errors = (0, utils_1.checkEdges)({
        friendlyName,
        inputs,
        outputs,
        isAllowedInputNode: (inputNode) => {
            return inputNode.nodeType === 'file_generatedLoanTape';
        },
        minInputs: 1,
        maxInputs: 100, // calc-agent can have multiple loan products.
        minOutputs: 1,
        maxOutputs: 1,
    });
    // there should be only one calc-agent node per credit facility.
    const calAgentsForCF = graph.nodes
        .filter(commonProps.isNode)
        .filter((calcAgent) => calcAgent.configuration.creditFacilitySlug ===
        node.configuration.creditFacilitySlug);
    if ((0, utils_1.getLowestNodeIdIfMultiple)(calAgentsForCF) ===
        node.metadata.tapeBuilderNodeId) {
        errors.push(`There should be only one CalcAgent for [${node.configuration.creditFacilitySlug}]. Found [${calAgentsForCF.length}].`);
    }
    return errors;
};
exports.operation_calcAgent = {
    ...commonProps,
    nodeType: types_1.nodeType,
    operationType: 'bbpl',
    createNewNode,
    hasValidConfig,
};
//# sourceMappingURL=uinode.js.map